const item = {
    item1: require('../images/items/item-01.jpg'),
    item2: require('../images/items/item-02.jpg'),
    item3: require('../images/items/item-03.jpg'),
    item4: require('../images/items/item-04.jpg'),
    item5: require('../images/items/item-05.jpg'),
    item6: require('../images/items/item-06.jpg'),
    item7: require('../images/items/item-07.jpg'),
    item8: require('../images/items/item-08.jpg'),
    item9: require('../images/items/item-09.jpg'),
    item10: require('../images/items/item-10.jpg'),
    item11: require('../images/items/item-11.jpg'),
    item12: require('../images/items/item-12.jpg'),
    item13: require('../images/items/item-13.jpg'),
    item14: require('../images/items/item-14.jpg'),
    item15: require('../images/items/item-15.jpg'),
    item16: require('../images/items/item-16.jpg'),
    item17: require('../images/items/item-17.jpg'),
    item18: require('../images/items/item-18.jpg'),
    item19: require('../images/items/item-19.jpg'),
    item20: require('../images/items/item-20.png'),
    item21: require('../images/items/item-21.png'),
    item22: require('../images/items/item-22.png'),
    item23: require('../images/items/item-23.png'),
    item25: require('../images/items/item-25.png'),
    item26: require('../images/items/item-26.png'),
    item27: require('../images/items/item-27.png'),
    item28: require('../images/items/item-28.png'),
    item29: require('../images/items/item-29.png'),
    item30: require('../images/items/item-30.png'),
    item31: require('../images/items/item-31.png'),
    item32: require('../images/items/item-32.png'),
    item33: require('../images/items/item-33.png'),
    item34: require('../images/items/item-34.png'),
    item35: require('../images/items/item-35.png'),
    item36: require('../images/items/item-36.png'),
    item37: require('../images/items/item-37.png'),
    item38: require('../images/items/item-38.png'),
    item39: require('../images/items/item-39.png'),
    item40: require('../images/items/item-40.png'),
    item41: require('../images/items/item-41.png'),
    item42: require('../images/items/item-42.png'),
    item43: require('../images/items/item-43.png'),
    item44: require('../images/items/item-44.png'),
    item45: require('../images/items/item-45.png'),
    item46: require('../images/items/item-46.png'),
    item47: require('../images/items/item-47.png'),
    item48: require('../images/items/item-48.png'),
    item49: require('../images/items/item-49.png'),
    item50: require('../images/items/item-50.png'),
    item51: require('../images/items/item-51.png'),
    item52: require('../images/items/item-52.png'),
    item53: require('../images/items/item-53.png'),
    item54: require('../images/items/item-54.png'),
    item55: require('../images/items/item-55.png'),
    item56: require('../images/items/item-56.png'),
    item57: require('../images/items/item-57.png'),
    item58: require('../images/items/item-58.png'),
    item59: require('../images/items/item-59.png'),
    item60: require('../images/items/item-60.png'),
    item61: require('../images/items/item-61.png'),
    item62: require('../images/items/item-62.png'),
    item63: require('../images/items/item-63.png'),
    item64: require('../images/items/item-64.png'),
    item65: require('../images/items/item-65.png'),
    item66: require('../images/items/item-66.png'),
    item67: require('../images/items/item-67.png'),
    item68: require('../images/items/item-68.png'),
    item69: require('../images/items/item-69.png'),
    item70: require('../images/items/item-70.png'),
    item71: require('../images/items/item-71.png'),
    item72: require('../images/items/item-72.png'),
    item73: require('../images/items/item-73.png'),
    item74: require('../images/items/item-74.png'),
    item75: require('../images/items/item-75.png'),
    item76: require('../images/items/item-76.png'),
    item77: require('../images/items/item-77.png'),
    item78: require('../images/items/item-78.png'),
    item79: require('../images/items/item-79.png'),
    item80: require('../images/items/item-80.png'),
    item81: require('../images/items/item-81.png'),
    item82: require('../images/items/item-82.png'),
    item83: require('../images/items/item-83.png'),
    item84: require('../images/items/item-84.png'),
    item85: require('../images/items/item-85.png'),
    item86: require('../images/items/item-86.png'),
    item87: require('../images/items/item-87.png'),
    item88: require('../images/items/item-88.png'),
    item89: require('../images/items/item-89.png'),
    item90: require('../images/items/item-90.png'),
    item91: require('../images/items/item-91.png'),
    item92: require('../images/items/item-92.png'),
    item93: require('../images/items/item-93.png'),
    item94: require('../images/items/item-94.png'),
    item95: require('../images/items/item-95.png'),
    item96: require('../images/items/item-96.png'),
    item97: require('../images/items/item-97.png'),
    item98: require('../images/items/item-98.png'),
    item99: require('../images/items/item-99.png'),
    item100: require('../images/items/item-100.png'),
    item101: require('../images/items/item-101.png'),
    item102: require('../images/items/item-102.png'),
    item103: require('../images/items/item-103.png'),
    item104: require('../images/items/item-104.png'),
    item105: require('../images/items/item-105.png'),
    item106: require('../images/items/item-106.png'),
    item107: require('../images/items/item-107.png'),
    item108: require('../images/items/item-108.png'),
    item109: require('../images/items/item-109.png'),
    item110: require('../images/items/item-110.png'),
    item111: require('../images/items/item-111.png'),
    item112: require('../images/items/item-112.png'),
    item113: require('../images/items/item-113.png'),
    item114: require('../images/items/item-114.png'),
    item115: require('../images/items/item-115.png'),
    item116: require('../images/items/item-116.png'),
    item117: require('../images/items/item-117.png'),
    item118: require('../images/items/item-118.png'),
    item119: require('../images/items/item-119.png'),
    item120: require('../images/items/item-120.png'),
    item121: require('../images/items/item-121.png'),
    item122: require('../images/items/item-122.png'),
    item123: require('../images/items/item-123.png'),
    item124: require('../images/items/item-124.png'),
    item125: require('../images/items/item-125.png'),
    item126: require('../images/items/item-126.png'),
    item127: require('../images/items/item-127.png'),
    item128: require('../images/items/item-128.webp'),
    item129: require('../images/items/item-129.webp'),
    item130: require('../images/items/item-130.webp'),
    item131: require('../images/items/item-131.webp'),
    item132: require('../images/items/item-132.webp'),
    item133: require('../images/items/item-133.webp'),
    item134: require('../images/items/item-134.webp'),
    item135: require('../images/items/item-135.webp'),
    item136: require('../images/items/item-136.webp'),
    item137: require('../images/items/item-137.webp'),
    item138: require('../images/items/item-138.webp'),
    item139: require('../images/items/item-139.webp'),
    item140: require('../images/items/item-140.webp'),
    item141: require('../images/items/item-141.webp'),
    item142: require('../images/items/item-142.webp'),
    item143: require('../images/items/item-143.webp'),
    item144: require('../images/items/item-144.webp'),
    item145: require('../images/items/item-145.webp'),
    item146: require('../images/items/item-146.webp'),
    item147: require('../images/items/item-147.webp'),
    item148: require('../images/items/item-148.webp'),
    item149: require('../images/items/item-149.webp'),
    item150: require('../images/items/item-150.webp'),
    // item 108
    storybg1: require('../images/items/story-bg-01.jpg'),
    story1: require('../images/items/story-01.png'),
    storybg2: require('../images/items/story-bg-02.jpg'),
    story2: require('../images/items/story-02.png'),
    storybg3: require('../images/items/story-bg-03.jpg'),
    story3: require('../images/items/story-03.png'),
    storybg4: require('../images/items/story-bg-04.jpg'),
    story4: require('../images/items/story-04.png'),
    storybg5: require('../images/items/story-bg-05.png'),
    story5: require('../images/items/story-05.png'),
    story6: require('../images/items/story-06.png'),
    storybg6: require('../images/items/story-bg-06.png'),
    profileMayanCoins: require('../images/profiles/mayan-coins.jpg'),
    profile5CrownFire: require('../images/profiles/5-crown-fire.png'),
    profileLostBook: require('../images/profiles/lost-book.jpg'),
    profile40WildClover: require('../images/profiles/40-wild-clover.jpg'),
    profileBookOfDread: require('../images/profiles/book-of-dread.png'),
    profileSpookySpins: require('../images/profiles/spooky-spins.jpg'),
    profileBookOfScorpio: require('../images/profiles/book-of-scorpio.png'),
}

export default item;